var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('Message'),_c('ModalCounter'),_c('MessagePayment'),_c('router-view'),_c('Popup-container'),_c('ResizeModal'),_c('Dialog',{ref:"confirmDialog"}),_c('Whatsapp'),_c('InfoControl')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }